// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__0kbTO","container":"styles_container__CEPUO","footer":"styles_footer__DcuuY"};